<div class="flex flex-col gap-2">
  @if (!hideTitleAndDescription()) {
    <p class="text-sm text-shikenso-purple-base-60 mb-3" data-testid="campaign-details-deliverables-description">
      {{ 'pages.campaignDetails.deliverables.description' | translate }}
    </p>

    <span class="text-sm mb-1">
      {{ 'pages.campaignDetails.deliverables.filters.title' | translate }}
    </span>
  }

  <div class="flex flex-wrap items-center gap-4 pl-1">
    <app-campaign-details-deliverables-filter-select
      class="w-[252px]"
      [emptyLabel]="ctaTemplateEmptyLabel()"
      [loading]="isContentLoading()"
      [options]="filterOptions().ctaTemplateNames"
      [searchPlaceholder]="'pages.campaignDetails.deliverables.filters.searchDeliverableGroup' | translate"
      [selectedValues]="filterState().ctaTemplateNames"
      (selectionChanged)="onCtaTemplateNamesChanged($event)"
    />

    <app-campaign-details-deliverables-filter-select
      class="w-[252px]"
      [emptyLabel]="deliverableTypeEmptyLabel()"
      [loading]="isContentLoading()"
      [options]="filterOptions().deliverableTypes"
      [searchPlaceholder]="'pages.campaignDetails.deliverables.filters.searchDeliverableType' | translate"
      [selectedValues]="filterState().deliverableTypes"
      (selectionChanged)="onDeliverableTypesChanged($event)"
    />

    <app-campaign-details-deliverables-filter-select
      class="w-[252px]"
      [emptyLabel]="matchingEmptyLabel()"
      [loading]="isContentLoading()"
      [options]="filterOptions().matchingTypes"
      [selectedValues]="filterState().matchingTypes"
      [showBulkActions]="true"
      [showSearch]="false"
      (selectionChanged)="onMatchingTypesChanged($event)"
    />
  </div>

  <div class="flex flex-col overflow-hidden w-full pl-2 mb-1">
    <div
      class="flex items-center"
      [class.justify-between]="campaignExportConfig().showDeliverablesStatusFilter"
      [class.justify-end]="!campaignExportConfig().showDeliverablesStatusFilter"
    >
      @if (campaignExportConfig().showDeliverablesStatusFilter) {
        <div class="flex items-center gap-6">
          <span class="text-xs text-shikenso-purple-base-60">
            {{ 'pages.campaignDetails.deliverables.filters.deliverableStatus' | translate }}
          </span>

          <app-campaign-details-deliverables-status-filters
            [loaderCount]="4"
            [loading]="isContentLoading()"
            [selectedStatuses]="filterState().statuses"
            [statusOptions]="visibleStatusOptions()"
            (selectedStatusesChanged)="onStatusesChanged($event)"
          />
        </div>
      }

      <app-campaign-details-deliverables-group-toggle
        [checked]="groupByContent()"
        (checkedChanged)="onGroupByContentChanged($event)"
      />
    </div>

    @if (filteredCreator()) {
      <app-filtered-creator-badge
        [creatorIcon]="filteredCreator()!.icon"
        [creatorName]="filteredCreator()!.name"
        (removed)="filteredCreatorRemoved.emit()"
      />
    }
  </div>

  <app-campaign-details-deliverables-table
    #tableRef
    [campaignExportConfig]="campaignExportConfig()"
    [contextColumn]="contextColumn()"
    [storageKeyPrefix]="storageKeyPrefix()"
    [groupedMode]="groupByContent()"
    [groupedRowData]="groupedRows()"
    [loading]="isContentLoading()"
    [rowData]="filteredRows()"
    (groupedRowGroupClicked)="deliverableRowGroupClicked.emit($event)"
    (rowClicked)="onDeliverableRowClicked($event)"
    (campaignClicked)="campaignClicked.emit($event)"
  />
</div>
